import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export const BackButton: React.FC<{
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}> = (props) => {
  const navigate = useNavigate();
  const handleBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const { t: tCommons } = useTranslationWithLang('commons');
  return (
    <button
      type="button"
      className={
        'text-[--c-button-border-secondary] ' +
        'border-2 ' +
        'border-[--c-button-border-secondary] ' +
        'font-bold ' +
        'my-6 ' +
        'min-w-[120px] ' +
        'hover:text-[--c-button-border-secondary-hover] ' +
        'hover:bg-[--c-button-background-secondary-hover] ' +
        'hover:border-[--c-button-border-secondary-hover] ' +
        'rounded ' +
        'py-4 ' +
        'rounded-full ' +
        (props.className || '')
      }
      style={props.style}
      onClick={props.onClick ? props.onClick : handleBack}
      title={tCommons('TU000_021')}
      aria-label={tCommons('TU000_021')}
    >
      {tCommons('TU000_021')}
    </button>
  );
};
